<template>
  <slick ref="slick" :options="slickOptions">
    <div v-for="(content, index) in this.contents" :key="index">
      <b-row class="justify-content-center">
        <b-col cols="4">
          <b-img
            :src="require('@/assets/icon/reason/' + content.img)"
            fluid
          />
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="12" class="sg-reason-title">
          {{ content.title }}
        </b-col>
        <b-col cols="12">
          {{ content.subtitle }}
        </b-col>
      </b-row>
    </div>
  </slick>
</template>

<script>
import Slick from 'vue-slick'
import 'slick-carousel/slick/slick.css'

export default {
  name: 'Carousel_Reason',
  props: ['contents'],
  components: {
    Slick
  },
  data () {
    return {
      slickOptions: {
        // options can be used from the plugin documentation
        autoplay: true,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: '',
        nextArrow: ''
      }
    }
  },
  methods: {
    /* vue slick prerequisites */
    next: function () {
      this.$refs.slick.next()
    },
    prev: function () {
      this.$refs.slick.prev()
    },
    reInit: function () {
      // Helpful if you have to deal with v-for to update dynamic lists
      this.$refs.slick.reSlick()
    }
    /* END vue slick prerequisites */
  }
}
</script>

<style scoped>
.sg-reason-title {
  font-size: 26px;
  font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// src/components/Carousel/Reason/Reason.vue